import { render, staticRenderFns } from "./RejectionStockItemsTable.vue?vue&type=template&id=b77236d0&"
import script from "./RejectionStockItemsTable.vue?vue&type=script&lang=js&"
export * from "./RejectionStockItemsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports